/* ============================================================
   AUROVRA — Animations globales
   1. Reveal au scroll  (.aurovra-reveal → .is-revealed)
   2. Science section   (pinned scroll, cartes une par une)
   ============================================================ */

(function () {
  'use strict';

  /* ────────────────────────────────────────────────────────────
     1. REVEAL GÉNÉRAL
     Tout élément portant .aurovra-reveal devient visible
     dès qu'il entre dans le viewport.
     Délai personnalisable via --aurovra-reveal-delay (CSS var).
  ──────────────────────────────────────────────────────────── */
  function initReveal(root) {
    root = root || document;
    var els = Array.prototype.slice.call(root.querySelectorAll('.aurovra-reveal:not(.is-revealed)'));
    if (!els.length) return;

    if (!('IntersectionObserver' in window)) {
      els.forEach(function (el) { el.classList.add('is-revealed'); });
      return;
    }

    var obs = new IntersectionObserver(function (entries, o) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        entry.target.classList.add('is-revealed');
        o.unobserve(entry.target);
      });
    }, { threshold: 0.12, rootMargin: '0px 0px -40px 0px' });

    els.forEach(function (el) { obs.observe(el); });
  }

  /* ────────────────────────────────────────────────────────────
     2. SCIENCE — PINNED SCROLL
     La section se bloque à l'écran pendant que les cartes
     défilent une par une, puis le scroll reprend normalement.

     Structure HTML requise :
       <section class="aurovra-science aurovra-science--pinned">
         <div class="aurovra-science__sticky">
           ...
           <div class="aurovra-science__cards">
             <div data-science-card data-card-index="0">
             <div data-science-card data-card-index="1">
             <div data-science-card data-card-index="2">
           </div>
           <div class="aurovra-science__cta-wrap" data-science-cta>
         </div>
       </section>
  ──────────────────────────────────────────────────────────── */
  function initSciencePinned() {
    var section = document.querySelector('.aurovra-science--pinned');
    if (!section) return;

    var cards   = Array.prototype.slice.call(section.querySelectorAll('[data-science-card]'));
    var ctaWrap = section.querySelector('[data-science-cta]');
    if (!cards.length) return;

    var segments = [
      [0.05, 0.28],
      [0.35, 0.58],
      [0.65, 0.85]
    ];

    function easeOutCubic(t) { return 1 - Math.pow(1 - t, 3); }
    function clamp(v, lo, hi) { return v < lo ? lo : v > hi ? hi : v; }

    function getProgress() {
      var rect    = section.getBoundingClientRect();
      var wh      = window.innerHeight;
      var total   = rect.height - wh;
      var scrolled = -rect.top;
      return clamp(scrolled / total, 0, 1);
    }

    function update() {
      var p      = getProgress();
      var mobile = window.innerWidth <= 749;

      cards.forEach(function (card, i) {
        var seg = segments[i] || [0, 0.3];

        if (mobile) {
          /* ── MOBILE : reel (glissement horizontal, une carte à la fois) ── */
          if (p < seg[0]) {
            /* Pas encore arrivé → hors écran à droite */
            card.style.opacity   = '1';
            card.style.transform = 'translateX(110%)';
          } else if (p >= seg[1]) {
            /* Déjà passé → hors écran à gauche */
            card.style.opacity   = '1';
            card.style.transform = 'translateX(-110%)';
          } else {
            var t = (p - seg[0]) / (seg[1] - seg[0]); /* 0→1 dans le segment */
            var x;
            if (t < 0.2) {
              /* Entrée : glisse depuis la droite */
              x = 110 * (1 - easeOutCubic(t / 0.2));
            } else if (t > 0.8) {
              /* Sortie : glisse vers la gauche */
              x = -110 * easeOutCubic((t - 0.8) / 0.2);
            } else {
              x = 0; /* Stable au centre */
            }
            card.style.opacity   = '1';
            card.style.transform = 'translateX(' + Math.round(x) + '%)';
          }
        } else {
          /* ── DESKTOP : fondu + translateY (comportement original) ── */
          var local = (p - seg[0]) / (seg[1] - seg[0]);
          var t     = easeOutCubic(clamp(local, 0, 1));

          card.style.opacity   = t;
          card.style.transform = 'translateY(' + Math.round(80 * (1 - t)) + 'px)';

          if (t >= 0.99 && !card.classList.contains('card-done')) {
            card.classList.add('card-done');
          }
        }
      });

      /* CTA — desktop uniquement */
      if (ctaWrap) {
        var lt = easeOutCubic(clamp((p - 0.87) / 0.08, 0, 1));
        ctaWrap.style.opacity   = lt;
        ctaWrap.style.transform = 'translateY(' + Math.round(16 * (1 - lt)) + 'px)';
      }
    }

    window.addEventListener('scroll', update, { passive: true });
    window.addEventListener('resize', update, { passive: true });
    update();
  }

  /* ────────────────────────────────────────────────────────────
     INIT
  ──────────────────────────────────────────────────────────── */
  function init(root) {
    initReveal(root);
    initSciencePinned();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { init(); });
  } else {
    init();
  }

  /* Support éditeur Shopify (rechargement de section en live) */
  if (window.Shopify && Shopify.designMode) {
    document.addEventListener('shopify:section:load', function (e) {
      init(e.target);
    });
    document.addEventListener('shopify:section:reorder', function () {
      init();
    });
  }

})();
